export enum CommonRoutes {
  EMPTY = 'empty',
  NOT_FOUND = 'not-found',
  OAUTH_ERROR = 'oauth-error',
  GENERIC_ERROR = 'error',
  AUTHORIZATION_ERROR = 'authorization-error'
}
